<ng-template #thisModalForm role="document" let-modal>

  <app-modal-comp-header
    [fileLockHoverText]="fileLockHoverText"
    [padlockIsLocked]="!billedOverrideUnlocked"
    [padlockLockedTitle]="'Unlock billing terms for editing'"
    [padlockUnlockedTitle]="'Re-lock billing terms'"
    [showFileLockIcon]="formIsLocked"
    [showPadlockIcon]="showBilledPadlock"
    [title]="formTitle"
    (cancelButtonOnClick)="thisFormCancel()"
    (padlockButtonOnClick)="padlockButtonClick()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="thisFormSubmitAttempt()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      @if (progressInformationShow) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                <span [innerHtml]="progressInformation"></span>
              </div>
            </div>
          </div>
        </div>
      }
      
      <div class="row">
        <div [ngClass]="(isBundle || isFeature || isPlatform || isPoolBundle || isUsage ? 'col-6' : 'col-12')">
          <div class="mb-3">
            <label for="licenceTypeId-field" class="form-label text-right">Licence Type</label>
            <div class="input-group">
              <select
                class="form-select"
                name="licenceTypeId-field"
                id="licenceTypeId-field"
                formControlName="licenceTypeId"
                [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['licenceTypeId'].errors }"
              >
                <option selected></option>
                @for (object of getDropdownDataObjectArray("licenceTypeId"); track object.id) {
                  <option [ngValue]="object.id">{{object.description}}</option>
                }
              </select>
              <div class="invalid-feedback">A value is required</div>
            </div>
          </div>
        </div>

        <div class="col-6">
          @if (isBundle || isFeature || isPlatform || isPoolBundle || isUsage) {
            <div class="mb-3">
              <label for="licenceName-field" class="form-label">{{isPoolBundle ? 'Pool Name' : 'Licence Name'}}</label>
              <input autocomplete="no-fill" type="text" id="licenceName-field" class="form-control" placeholder="" formControlName="licenceName" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['licenceName'].errors }" />
              @if (formOfThis['licenceName'].hasError('maxlength')) {
                <div class="invalid-feedback">Maximum length of {{licenceNameMaxLength}} characters has been exceeded</div>
              } @else {
                <div class="invalid-feedback">A value is required</div>
              }
            </div>
          }
        </div>
      </div>

      @if (isBundle || isPoolBundle || isUsage) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="zoneIDs-field" class="form-label text-right">Zone Configuration</label>
              <ng-select #zoneSelect
                bindLabel="description"
                bindValue="id"
                class="zone-multi-select"
                [closeOnSelect]="false"
                formControlName="zoneIDs"
                id="zoneIDs-field"
                [items]="getDropdownDataObjectArray('zoneId') ?? []"
                [multiple]="true"
                [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['zoneIDs'].errors }"
                placeholder="Select zones to add..."
                (change)="sortSelectedZones()"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="zone-pill" [class.zone-pill--premium]="isPremiumZone(item)">
                    <span class="zone-pill__label">{{ item.description }}</span>
                    @if (!formOfThis['zoneIDs'].disabled) {
                      <span class="zone-pill__clear ng-value-icon" aria-hidden="true" (click)="clear(item)">×</span>
                    }
                  </span>
                </ng-template>
                <ng-template ng-footer-tmp>
                  <div class="zone-select-footer-group">
                    <div class="zone-select-footer-row">
                      <div class="zone-select-footer-btn zone-select-footer-btn--danger" (click)="selectAllZones()">Select All</div>
                      <div class="zone-select-footer-btn zone-select-footer-btn--primary" (click)="selectAllZonesExcludingPremium()">Select All Excl. Premium</div>
                    </div>
                    <div class="zone-select-footer-row">
                      <div class="zone-select-footer-btn zone-select-footer-btn--success" (click)="zoneSelect.close()">Done</div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
              @if (thisFormSubmitted && formOfThis['zoneIDs'].errors) {
                <div class="invalid-feedback d-block">At least one zone is required</div>
              }
            </div>
          </div>
        </div>
      }

      @if (isBundle) {
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label class="form-label text-right">Bundle Period</label>
              <div class="btn-group w-100 pill-toggle" role="group" aria-label="Bundle Period">
                @for (object of getDropdownDataObjectArray('bundlePeriodTypeId'); track object.id) {
                  <input
                    formControlName="bundlePeriodTypeId"
                    [id]="'bundlePeriodTypeId-' + object.id"
                    [value]="object.id"
                    type="radio" class="btn-check"
                  >
                  <label
                    class="btn btn-outline-success mb-0"
                    [class.is-invalid]="thisFormSubmitted && formOfThis['bundlePeriodTypeId'].errors"
                    [for]="'bundlePeriodTypeId-' + object.id"
                  >{{object.description}}</label>
                }
              </div>
              @if (thisFormSubmitted && formOfThis['bundlePeriodTypeId'].errors) {
                <div class="invalid-feedback d-block">A value is required</div>
              }
            </div>
          </div>
          @if (isAnnualBundlePeriod) {
            <div class="col-4">
              <div class="mb-3">
                <label class="form-label text-right">Billing Frequency</label>
                <div class="btn-group w-100 pill-toggle" role="group" aria-label="Billing Frequency">
                  @for (object of getDropdownDataObjectArray('paymentFrequencyTypeId'); track object.id) {
                    <input
                      formControlName="paymentFrequencyTypeId"
                      [id]="'paymentFrequencyTypeId-' + object.id"
                      [value]="object.id"
                      type="radio" class="btn-check"
                    >
                    <label
                      class="btn btn-outline-success mb-0"
                      [class.is-invalid]="thisFormSubmitted && formOfThis['paymentFrequencyTypeId'].errors"
                      [for]="'paymentFrequencyTypeId-' + object.id"
                    >{{object.description}}</label>
                  }
                </div>
                @if (thisFormSubmitted && formOfThis['paymentFrequencyTypeId'].errors) {
                  <div class="invalid-feedback d-block">A value is required</div>
                }
              </div>
            </div>
          }
          <div class="col-4">
            <div class="mb-3">
              <label for="allowanceMbOrGb-field" class="form-label">Allowance GB</label>
              <input
                autocomplete="no-fill"
                class="form-control text-end"
                data-lpignore="true"
                formControlName="allowanceMbOrGb"
                id="allowanceMbOrGb-field"
                [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['allowanceMbOrGb'].errors }"
                placeholder=""
                type="number"
                (keydown)="preventDecimal($event)"
              />
              <div class="invalid-feedback">A value is required</div>
            </div>
          </div>
        </div>
      }

      @if (isPoolBundle) {
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label for="allowanceMbOrGb-field" class="form-label">Data Per Licence</label>
              <div class="data-weight-input-group">
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="allowanceMbOrGb"
                  id="allowanceMbOrGb-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['allowanceMbOrGb'].errors }"
                  placeholder=""
                  type="number"
                  (keydown)="preventDecimal($event)"
                />
                <div class="btn-group pill-toggle" role="group" aria-label="Data Weight">
                  @for (object of getDropdownDataObjectArray('dataWeightTypeId'); track object.id) {
                    <input
                      formControlName="dataWeightTypeId"
                      [id]="'dataWeightTypeId-' + object.id"
                      [value]="object.id"
                      type="radio" class="btn-check"
                    >
                    <label class="btn btn-outline-success mb-0"
                           [class.is-invalid]="thisFormSubmitted && formOfThis['dataWeightTypeId'].errors"
                           [for]="'dataWeightTypeId-' + object.id">{{ dataWeightShortCode(object) }}</label>
                  }
                </div>
              </div>
              <div class="form-text">Data contribution per Platform licence</div>
              @if (thisFormSubmitted && (formOfThis['allowanceMbOrGb'].errors || formOfThis['dataWeightTypeId'].errors)) {
                <div class="invalid-feedback d-block">A value is required</div>
              }
            </div>
          </div>
          @if (poolBundlePeriodEnabled) {
            <div class="col-4">
              <div class="mb-3">
                <label class="form-label text-right">Pool Period</label>
                <div class="btn-group w-100 pill-toggle" role="group" aria-label="Pool Period">
                  @for (object of getDropdownDataObjectArray('bundlePeriodTypeId'); track object.id) {
                    <input
                      formControlName="bundlePeriodTypeId"
                      [id]="'bundlePeriodTypeId-' + object.id"
                      [value]="object.id"
                      type="radio" class="btn-check"
                    >
                    <label
                      class="btn btn-outline-success mb-0"
                      [class.is-invalid]="thisFormSubmitted && formOfThis['bundlePeriodTypeId'].errors"
                      [for]="'bundlePeriodTypeId-' + object.id"
                    >{{object.description}}</label>
                  }
                </div>
                @if (thisFormSubmitted && formOfThis['bundlePeriodTypeId'].errors) {
                  <div class="invalid-feedback d-block">A value is required</div>
                }
              </div>
            </div>
            @if (isAnnualBundlePeriod) {
              <div class="col-4">
                <div class="mb-3">
                  <label class="form-label text-right">Billing Frequency</label>
                  <div class="btn-group w-100 pill-toggle" role="group" aria-label="Billing Frequency">
                    @for (object of getDropdownDataObjectArray('paymentFrequencyTypeId'); track object.id) {
                      <input
                        formControlName="paymentFrequencyTypeId"
                        [id]="'paymentFrequencyTypeId-' + object.id"
                        [value]="object.id"
                        type="radio" class="btn-check"
                      >
                      <label
                        class="btn btn-outline-success mb-0"
                        [class.is-invalid]="thisFormSubmitted && formOfThis['paymentFrequencyTypeId'].errors"
                        [for]="'paymentFrequencyTypeId-' + object.id"
                      >{{object.description}}</label>
                    }
                  </div>
                  @if (thisFormSubmitted && formOfThis['paymentFrequencyTypeId'].errors) {
                    <div class="invalid-feedback d-block">A value is required</div>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="col-4">
              <div class="mb-3">
                <label class="form-label">Pool Period</label>
                <input
                  class="form-control"
                  disabled
                  type="text"
                  value="Monthly (Fixed)"
                />
                <div class="form-text">Pools are always calculated monthly</div>
              </div>
            </div>
          }
        </div>
      }

      @if (isUsage) {
        <div class="row">
          <div class="col-12">
            <div class="form-section-header">Custom Per-MB Pricing</div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label for="pricePerMb-field" class="form-label">Price per MB (GBP)</label>
              <div class="input-group">
                <span class="input-group-text">£</span>
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="pricePerMb"
                  id="pricePerMb-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['pricePerMb'].errors }"
                  placeholder=""
                  type="number"
                  (input)="enforceDecimals('pricePerMb', 8)"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="pricePerMbEur-field" class="form-label">Price per MB (EUR)</label>
              <div class="input-group">
                <span class="input-group-text">€</span>
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="pricePerMbEur"
                  id="pricePerMbEur-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['pricePerMbEur'].errors }"
                  placeholder=""
                  type="number"
                  (input)="enforceDecimals('pricePerMbEur', 8)"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="pricePerMbUsd-field" class="form-label">Price per MB (USD)</label>
              <div class="input-group">
                <span class="input-group-text">$</span>
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="pricePerMbUsd"
                  id="pricePerMbUsd-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['pricePerMbUsd'].errors }"
                  placeholder=""
                  type="number"
                  (input)="enforceDecimals('pricePerMbUsd', 8)"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="row">
        <div [ngClass]="isPlatform ? 'col-12' : 'col-6'">
          @if (isPlatform || (isFeature && showFeatureQuantity)) {
            <div class="mb-3">
              <label for="numberOfEntities-field" class="form-label">{{isPlatform==true ? 'Number of Licences' : 'Quantity'}}</label>
              <input
                autocomplete="no-fill"
                class="form-control text-end"
                data-lpignore="true"
                formControlName="numberOfEntities"
                id="numberOfEntities-field"
                [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['numberOfEntities'].errors }"
                placeholder=""
                type="number"
                (keydown)="preventDecimal($event)"
              />
              <div class="invalid-feedback">A value is required</div>
            </div>
          }
        </div>
      </div>

      @if (isFeature) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="featureGuid-field" class="form-label text-right">Feature</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="featureGuid-field"
                  id="featureGuid-field"
                  formControlName="featureGuid"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['featureGuid'].errors }"
                >
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray("featureGuid"); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (isUsage) {
        <div class="row">
          <div class="col-12">
            <div class="form-section-header">Rate Licence Fee</div>
          </div>
        </div>
      }

      @if (isBundle || isFeature || isPlatform || isUsage) {
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label for="price-field" class="form-label">Price (GBP)</label>
              <div class="input-group">
                <span class="input-group-text">£</span>
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="price"
                  id="price-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['price'].errors }"
                  placeholder=""
                  type="number"
                  (input)="enforceDecimals('price')"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="priceEur-field" class="form-label">Price (EUR)</label>
              <div class="input-group">
                <span class="input-group-text">€</span>
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="priceEur"
                  id="priceEur-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['priceEur'].errors }"
                  placeholder=""
                  type="number"
                  (input)="enforceDecimals('priceEur')"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="priceUsd-field" class="form-label">Price (USD)</label>
              <div class="input-group">
                <span class="input-group-text">$</span>
                <input
                  autocomplete="no-fill"
                  class="form-control text-end"
                  data-lpignore="true"
                  formControlName="priceUsd"
                  id="priceUsd-field"
                  [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['priceUsd'].errors }"
                  placeholder=""
                  type="number"
                  (input)="enforceDecimals('priceUsd')"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (isBundle || isUsage || isPoolBundle) {
        <div class="row">
          <div class="col-12">
            <div class="licence-switch-inline">

              <div class="licence-switch-inline-item">
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active">
                </div>
                <label class="licence-switch-label" for="active-field">Active</label>
              </div>

              <div class="licence-switch-inline-item">
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="adminLocked-field" formControlName="adminLocked">
                </div>
                <label class="licence-switch-label" for="adminLocked-field" [title]="isLicencesAdminKeyHolder ? '' : 'You do not have permission to change this setting'">Admin Lock</label>
              </div>

              <div class="licence-switch-inline-item">
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="addToNewCompany-field" formControlName="addToNewCompany">
                </div>
                <label class="licence-switch-label" for="addToNewCompany-field">Auto-assign to New Companies</label>
              </div>

              <div class="licence-switch-inline-item">
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="systemOwned-field" formControlName="systemOwned">
                </div>
                <label class="licence-switch-label" for="systemOwned-field">System Owned</label>
              </div>

            </div>
          </div>
        </div>
      } @else if (isFeature || isPlatform) {
        <div class="row">
          <div class="col-12">
            <div class="licence-switch-stack">

              <div class="licence-switch-row">
                <label class="licence-switch-label" for="active-field">Active</label>
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active">
                </div>
              </div>

              <div class="licence-switch-row">
                <label class="licence-switch-label" for="adminLocked-field" [title]="isLicencesAdminKeyHolder ? '' : 'You do not have permission to change this setting'">Admin Lock</label>
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="adminLocked-field" formControlName="adminLocked">
                </div>
              </div>

              @if (isFeature) {
                <div class="licence-switch-row">
                  <label class="licence-switch-label" for="allowMany-field">Allow Multiple Instances</label>
                  <div class="form-check form-switch form-switch-md">
                    <input class="form-check-input" type="checkbox" role="switch" id="allowMany-field" formControlName="allowMany">
                  </div>
                </div>
              }

              <div class="licence-switch-row">
                <label class="licence-switch-label" for="addToNewCompany-field">Auto-assign to New Companies</label>
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="addToNewCompany-field" formControlName="addToNewCompany">
                </div>
              </div>

              @if (isPlatform) {
                <div class="licence-switch-row">
                  <label class="licence-switch-label" for="platformAddOn-field">Platform Add-On</label>
                  <div class="form-check form-switch form-switch-md">
                    <input class="form-check-input" type="checkbox" role="switch" id="platformAddOn-field" formControlName="platformAddOn">
                  </div>
                </div>
              }

              @if (isFeature) {
                <div class="licence-switch-row">
                  <label class="licence-switch-label" for="quantityEnabled-field">Quantity Enabled</label>
                  <div class="form-check form-switch form-switch-md">
                    <input class="form-check-input" type="checkbox" role="switch" id="quantityEnabled-field" formControlName="quantityEnabled" (change)="onQuantityEnableChange($event)">
                  </div>
                </div>
              }

              <div class="licence-switch-row">
                <label class="licence-switch-label" for="systemOwned-field">System Owned</label>
                <div class="form-check form-switch form-switch-md">
                  <input class="form-check-input" type="checkbox" role="switch" id="systemOwned-field" formControlName="systemOwned">
                </div>
              </div>

            </div>
          </div>
        </div>
      }

      @if (isBundle || isFeature || isPlatform || isPoolBundle || isUsage) {

        <div class="row mt-3">
          <div class="col-12">
            <div class="alert alert-warning alert-progress-warning d-flex align-items-center mb-0" role="alert">
              <span class="alert-progress-warning__icon me-2">⚠️</span>
              <span>System Owned Licences cannot be added or removed by a SureSIM user</span>
            </div>
          </div>
        </div>
      }

      @if (licenceEverBilled && !billedOverrideUnlocked) {
        <div class="row mt-3">
          <div class="col-12">
            <div class="alert alert-danger d-flex align-items-center mb-0" role="alert">
              <i class="ri-error-warning-fill me-2"></i>
              <span>This licence has billed - its billing terms can no longer be edited</span>
            </div>
          </div>
        </div>
      }

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="thisFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" [disabled]="!submitButtonEnabled || formIsLocked" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalFormClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
